import { FilesReportsNavigation, ReportsPanel } from '@pages/files-reports/containers';
import { HasPermission } from '@shared/components';

export const Reports = () => {
  return (
    <HasPermission permissionFeature="REPORTS_FILES_REPORTS" permissionType="READ" redirect>
      <div className="flex justify-between mb-4">
        <FilesReportsNavigation />
      </div>

      <ReportsPanel />
    </HasPermission>
  );
};
